import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Button, Form, Icon } from 'semantic-ui-react'
import _find from 'lodash/find';
import general from '../../../modulos/general';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeguro from '../../../components/funcionales/estaseg7btn';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
var moment = require('moment');


// import general from '../../modulos/general';

//dropdown EMPRESAS
// const DetalleEmpNivel1 = props => {
//   return (
//     <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
//   )
// };

// const ListaEmp = ({styles, list, handleChange}) => {
//   const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
//         {/* <option value="">Seleccionar Empresa...</option> */}
//         {Nivel1Detalle}
//       </select>
//     </div>
//   )
// };
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  let colorCelda='white'
  if(elemento.numOrdenCompra!=='' && elemento.numOrdenCompra!==null && elemento.validezOferta!=='' && elemento.validezOferta!==null){
    if((elemento.validezOferta==='1 día' && elemento.numOrdenCompra>1) || (elemento.validezOferta==='3 días' && elemento.numOrdenCompra>3)
      || (elemento.validezOferta==='8 días' && elemento.numOrdenCompra>8) 
      || (elemento.validezOferta==='15 días' && elemento.numOrdenCompra>15) || (elemento.validezOferta==='30 días' && elemento.numOrdenCompra>30)
      || (elemento.validezOferta==='60 días' && elemento.numOrdenCompra>60) || (elemento.validezOferta==='90 días' && elemento.numOrdenCompra>90)
      ){
      colorCelda = 'red'
    }
  }

  return(
    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numCoti}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreUsuario}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorUniAprob?new Intl.NumberFormat('de-DE').format(elemento.valorUniAprob):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.cantidadAprob?new Intl.NumberFormat('de-DE').format(elemento.cantidadAprob):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.totalOC?new Intl.NumberFormat('de-DE').format(elemento.totalOC):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ordenCompraCliente?elemento.ordenCompraCliente:''}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaOrdenCliente?elemento.fechaOrdenCliente.substr(0, 10):''}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreContacto}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaEnvio?elemento.fechaEnvio.substr(0, 10):''}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.validezOferta}</td>
      
       <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoEnviado}
          href={urlSlcm + elemento.archivoEnviado}
            target="_blank">
          {elemento.archivoEnviado}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoRecibido}
          href={urlSlcm + elemento.archivoRecibido}
            target="_blank">
          {elemento.archivoRecibido}
        </a>
      </td>

    </tr>
  )
};
// href="#" onclick="window.location.href ='file:///./slcm-client/public/images/documentos/' + elemento.nombreDoc"

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetalleNivelLista = ({elementoI, handleClickidListaI, idListaI}) => {
  let precioActual=0
  if(elementoI.moneda==='Pesos'){
    precioActual=elementoI.valorUniCoti
  }else{
    precioActual=elementoI.numOrdenCompraCli
  }

  return(
    <tr className=''>
    {/* <tr className=''> */}
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.cantidadAprob}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.descrUnidad}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.descrProducto}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{new Intl.NumberFormat('de-DE').format(precioActual)}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{new Intl.NumberFormat('de-DE').format(elementoI.valorUniAprob)}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.porcDcto}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.porcIncremento}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{new Intl.NumberFormat('de-DE').format(elementoI.cantidadAprob * ((elementoI.valorUniAprob / ((100-elementoI.porcIncremento)/100)) * ((100-elementoI.porcDcto)/100)))}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.porcIVA}</td>
    </tr>
  )
};
const Lista = ({listI, handleClickidListaI, idListaI}) => {
  // console.log(listI)
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} handleClickidListaI={handleClickidListaI}
        key={i} idListaI={idListaI} 
        />);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AsocDocCoti2 extends React.Component {
  state={argsBuscCad: {}, idListaP: {}, idListaI: {}, procBtn: 0, permiteBtn1: true, permiteBtn2: true, confirmaAct: false, 
  open: false, argsDocum: {}, argsDocumI: {}, lista4: [], errorAdd: [],
  argsQuery: `{"$unwind": "$itemsCoti"},
  {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
      tipoProducto: '$itemsCoti.tipoProducto', 
      numProductoCoti: '$itemsCoti.numProductoCoti', 
      descrProducto: '$itemsCoti.descrProducto', 
      cantidadAprob: '$itemsCoti.cantidadAprob', 
      valorUniAprob: '$itemsCoti.valorUniAprob', 
      valorUniCoti: '$itemsCoti.valorUniCoti',
      porcDcto: '$itemsCoti.porcDcto',
      porcIncremento: '$itemsCoti.porcIncremento',
      porcIVA: '$itemsCoti.porcIVA',
      descrUnidad: '$itemsCoti.descrUnidad',
      moneda: '$itemsCoti.moneda'}},
    {$lookup: {from: 'productos', localField: 'numProductoCoti', foreignField: 'numProducto', as: 'producto'}},
    {$unwind: '$producto'},
    {$project: {_id: 1, numCoti: 1, tipoProducto: 1, descrProducto: 1, cantidadAprob: 1, valorUniAprob: 1, numProductoCoti: 1, 
      porcDcto: 1, porcIncremento: 1, porcIVA: 1, descrUnidad: 1, moneda: 1, valorUniCoti: '$producto.precio', numOrdenCompraCli: '$producto.precioDolar'}},
  {$sort: {descrProducto: 1}}`,

  argsQuery1: `{"$unwind": "$itemsCoti"},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
    monedaCoti: 1, imptoCoti: 1, fechaOrdenCliente: 1,
    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
    archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, ordenCompraCliente: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
    porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento',
    moneda: '$itemsCoti.moneda'}},
  {$match: {cantidadAprob: {$gt: 0}}},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
    monedaCoti: 1, imptoCoti: 1, fechaOrdenCliente: 1,
    ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
    validezOferta: 1, observacionesAut: 1, usuarioAut: 1, archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, ordenCompraCliente: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, 
    valorItemAsoc: {
      $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
      }
    },
    valorItemAsocIVA: {
      $let: {
        vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
        in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
      }
    }
  }},
{$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
  fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti', fechaOrdenCliente: '$fechaOrdenCliente',
  descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
  cargoContacto: '$cargoContacto', archivoEnviado: '$archivoEnviado', archivoRecibido: '$archivoRecibido', 
ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
  referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
  formaPago: '$formaPago', totalOC: '$totalOC', ordenCompraCliente: '$ordenCompraCliente', 
validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
  estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3'},
valorTotalAsoc: {$sum: {$toDouble: '$valorItemAsoc'}}, valorTotalAsocIVA: {$sum: {$toDouble: '$valorItemAsocIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
    numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
    monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti', fechaOrdenCliente: '$_id.fechaOrdenCliente',
    fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
    fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
      ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
      nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
      referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
      formaPago: '$_id.formaPago', archivoEnviado: '$_id.archivoEnviado', totalOC: '$_id.totalOC', 
      ordenCompraCliente: '$_id.ordenCompraCliente', archivoRecibido: '$_id.archivoRecibido', 
validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
      estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', 
      valorUniAprob: {$toDouble: '$valorTotalAsoc'}, cantidadAprob: {$toDouble: '$valorTotalAsocIVA'},
      numOrdenCompra: {
        $let: {
          vars: {fechaEnvioDif: "$_id.fechaEnvio"},
         in: {$cond: [
           {
             "$or":[
              { "$eq": [ "$$fechaEnvioDif", null ] },
              { "$eq": [ "$$fechaEnvioDif", '' ]},
             ]
           }, 
           1,
           { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaEnvioDif'} ]}, 86400000 ]}}
          ]
        }}
      }
  }}, {$sort: {fechaEnvio: -1}}`
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }
  

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()
    let argsDocum = this.state.argsDocum
    argsDocum['totalOC'] = idListaP.totalOC?idListaP.totalOC:0
    argsDocum['ordenCompraCliente'] = idListaP.ordenCompraCliente?idListaP.ordenCompraCliente:''
    argsDocum['fechaOrdenCliente'] = idListaP.fechaOrdenCliente?idListaP.fechaOrdenCliente:this.props.fechaHoy
    this.setState(argsDocum)    
    let argsBuscar=""
    argsBuscar += `'numCoti': '${idListaP.numCoti}'`
    let argsBuscarIt = {}
    argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
    let {data} = await this.props.allCotizacionRtesAsoc1.refetch(argsBuscarIt)
    if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
      this.setState({lista4: await data.allCotizacionRtes})
    }
    this.setState({idListaP: idListaP})
  }
  handleClickidListaI = async (ev, idListaI)=>{
    ev.preventDefault()

    this.setState({idListaI: idListaI})
    let argsDocumI = this.state.argsDocumI
    argsDocumI['cantidadAprob'] = idListaI.cantidadAprob
    argsDocumI['porcDcto'] = idListaI.porcDcto
    argsDocumI['porcIncremento'] = idListaI.porcIncremento
    this.setState(argsDocumI)
  } 
  idListaI = async (ev, idListaI)=>{
    this.setState({idListaI: idListaI})
    ev.preventDefault()
  };

  handleChange = async(ev)=>{
    const argsDocum = this.state.argsDocum
    const argsDocumI = this.state.argsDocumI

    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum});
    this.setState({idListaP: {}});
    let argsBuscar = `'estadoCoti': 'Enviada'`
    if(this.props.argsBuscCoti.numCoti){
      argsBuscar += `, 'numCoti': /${this.props.argsBuscCoti.numCoti}/i`
    }
    let argsBuscCoti = ""
    argsBuscCoti = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
    this.props.allCotizacionRtesAsoc.refetch(argsBuscCoti)
    this.setState({argsBuscCoti: this.props.argsBuscCoti})

    this.setState({argsDocumI});
    this.setState({idListaI: {}});    
    argsBuscar = `'estadoCoti': 'Enviada'`
    if(this.props.argsBuscCoti.numCoti){
      argsBuscar += `, 'numCoti': /${this.props.argsBuscCoti.numCoti}/i`
    }    
    let argsBuscarIt = {}
    argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
    let {data} = await this.props.allCotizacionRtesAsoc1.refetch(argsBuscarIt)
    this.setState({lista4: await data.allCotizacionRtes})
  }

  handleChangeI = async(ev, numCoti, descrProducto)=>{
    const argsDocumI = this.state.argsDocumI
    argsDocumI[ev.target.name] = ev.target.value
    argsDocumI['numCoti'] = numCoti
    argsDocumI['descrProducto'] = descrProducto

    this.setState({argsDocumI});
    console.log(this.state.argsDocumI)
  }

  handleChangeTotal = async(ev)=>{
    const argsDocum = this.state.argsDocum
    const idListaP = this.state.idListaP

    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum});
    idListaP[ev.target.name] = ev.target.value
    this.setState({idListaP});
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'estadoCoti': 'Enviada'`
      // argsBuscar += `, 'descrEmpresa': /${this.state.argsDocum.descrEmpresa}/i`

      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numCoti){
        argsBuscar += `, 'numCoti': /${this.props.argsBuscCad.numCoti}/i`
      }
      if(this.props.argsBuscCad.nombreUsuario){
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscCad.nombreUsuario}/i`
      }
      let argsBuscCoti = ""
      argsBuscCoti = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      // argsBuscCoti = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {fechaEnvio: -1}}, {$limit: 100}]`}
console.log(argsBuscCoti)
      await this.props.allCotizacionRtesAsoc.refetch(argsBuscCoti)
      // this.setState({argsBuscCad: this.props.argsBuscCad})
    }
  }

  handleRtaCoti = async (idListaP, rta, list4)=>{
    console.log(idListaP)
    if(idListaP.numCoti){
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaRta = fechaHoraHoy
      let usuarioRta = localStorage.getItem('userLogin')
      document.body.style.cursor = 'wait'
      let numOrdenCompra = 0
      let estadoOC = ''
      if(rta==='Aceptada'){
        let allEmpresa = this.props.allEmpresa.allEmpresa
        let indexEmp = allEmpresa.findIndex( empresa => empresa.descrEmpresa===idListaP.descrEmpresa.replace(/^\s+|\s+$/g, ''))
        let valorCero = indexEmp===-1?'N':allEmpresa[indexEmp].OCValorCero?allEmpresa[indexEmp].OCValorCero:'N'
console.log(idListaP.ordenCompraCliente, Intl.NumberFormat('de-DE').format(idListaP.cantidadAprob), parseInt(idListaP.cantidadAprob), Intl.NumberFormat('de-DE').format(idListaP.totalOC))
        if(idListaP.ordenCompraCliente && new Intl.NumberFormat('de-DE').format(idListaP.cantidadAprob)===Intl.NumberFormat('de-DE').format(idListaP.totalOC)){
          if(idListaP.archivoRecibido){
            numOrdenCompra = await this.nextVal('ordenCompra')
            estadoOC = 'Creada'
            let argsAddI = {}
              
            let list5 = this.props.allEncuesta.allEncuesta
            list5.forEach (async (item, i) => {
              argsAddI = {
                "_id": idListaP._id,
                "pregunta": list5[i].pregunta,
                "respuesta": '',
                "valoracion": 0,
                "tipoAct": "CrearItemEncuesta"
              }
            
              let response = await this.props.editCotizacion({
                variables: argsAddI
              });
              const {errorsI, successI} = response.data.editCotizacion;
              argsAddI = {}
              if (!successI){
                this.setState({errorAddI: errorsI})
              }
            })

            this.setState({argsAdd: {}})
            this.props.allCotizacionRtesAsoc.refetch()
            this.setState({lista4: []})
          }else{
            alert("!! Es necesario adjuntar el PDF de la orden de compra enviada por el cliente !!")
          }
        }else{
          alert("!! El valor total de la cotización no coincide con el total de la orden de compra enviado por el cliente o no han registrado el número de la orden de compra del cliente !!")
        }
      }

      if((rta==='Aceptada' && new Intl.NumberFormat('de-DE').format(idListaP.cantidadAprob)===Intl.NumberFormat('de-DE').format(idListaP.totalOC) && idListaP.archivoRecibido) || (rta==='Rechazada')){
        const argsUpd = {
          _id: idListaP._id,
          estadoCoti: rta,
          estadoOC: estadoOC,
          fechaRta: fechaRta,
          usuarioRta: usuarioRta,
          numOrdenCompra: numOrdenCompra,
          cedula: idListaP.cedula,
          nombreUsuario: idListaP.nombreUsuario,
          totalOC: parseInt(idListaP.totalOC),
          usuarioTotalOC: usuarioRta,
          tipoAct: 'EditarRta'
        }
        response = await this.props.editCotizacion({
          variables: argsUpd
        });
        const {errors, success} = response.data.editCotizacion;

        if (!success){
          this.setState({errorAdd: errors})
        }else{
          this.props.allCotizacionRtesAsoc.refetch()
          document.body.style.cursor = 'default'

          alert("!! Respuesta registrada !!")
        }
      }
      document.body.style.cursor = 'default'
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
    this.setState({permiteBtn1: true, open: false, confirmaAct: false})
  }

  handleCantidad = async (idListaP, idListaI, cantidad, dcto, incre)=>{
    if(idListaI.descrProducto){
      document.body.style.cursor = 'wait'
      let tipoAc=''
      if(idListaI.numProductoCoti && idListaI.numProductoCoti>0){
        tipoAc = 'EditarItemID'
      }else{
        tipoAc = 'EditarItem'
      }
      const argsUpd = {
        _id: idListaP._id,
        cantidadAprob: parseInt(cantidad),
        porcDcto: parseInt(dcto),
        porcIncremento: parseInt(incre),
        descrProducto: idListaI.descrProducto,
        numProductoCoti: idListaI.numProductoCoti?idListaI.numProductoCoti:0,
        tipoAct: 'EditarItem'
      }
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        let argsBuscar=""
        argsBuscar += `'numCoti': '${idListaP.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtesAsoc1.refetch(argsBuscarIt)
        this.setState({lista4: await data.allCotizacionRtes})
        this.setState({idListaI: idListaI})
        this.props.allCotizacionRtesAsoc.refetch()
        document.body.style.cursor = 'default'

        alert("!! Datos registrados !!")
      }
    }else{
      alert("!! Por favor seleccione un producto !!")
    }

  }

  handleTotal = async (idListaP, totalOC, ordenCompraCliente, fechaOrdenCliente)=>{
    if(idListaP.numCoti){
      document.body.style.cursor = 'wait'
      let usuarioTotalOC = localStorage.getItem('userLogin')
      let fechaCliente = moment(fechaOrdenCliente).format('YYYY-MM-DD')
      const argsUpd = {
        _id: idListaP._id,
        totalOC: parseFloat(totalOC),
        usuarioTotalOC: usuarioTotalOC,
        ordenCompraCliente: ordenCompraCliente?ordenCompraCliente:'',
        fechaOrdenCliente: fechaCliente,
        tipoAct: 'EditarTotal'
      }
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.props.allCotizacionRtesAsoc.refetch()
        document.body.style.cursor = 'default'

        alert("!! Total registrado !!")
      }
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
  }

  handleReversar = async (idListaP)=>{
    if(idListaP.numCoti){
      document.body.style.cursor = 'wait'

      const argsUpd = {
        _id: idListaP._id,
        estadoCoti: 'Aprobada',
        fechaEnvio: '',
        usuarioEnvio: '',
        tipoAct: 'EditarEnvio'
      }

      let response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.props.allCotizacionRtesAsoc.refetch()
        document.body.style.cursor = 'default'

        alert("!! Estado reversado !!")
      }
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }


  render(){
    const {idListaP, idListaI, permiteBtn1, permiteBtn2, confirmaAct, open, argsDocum, argsDocumI} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let list = [], list2 = [], list4 = []  
    if(this.props.allCotizacionRtesAsoc.allCotizacionRtes){
      this.props.allCotizacionRtesAsoc.refetch()
      list = this.props.allCotizacionRtesAsoc.allCotizacionRtes
    }
    // if(this.props.allEmpresa.allEmpresa){list2 = this.props.allEmpresa.allEmpresa}
    if(this.state.lista4){list4 = this.state.lista4}
console.log(idListaP)
console.log(argsDocum)

    // console.log(ev.target.files[0])
    // let mensaje1 = "Eliminar PDF enviado de "
    // let mensajeAsImCoti = "Asociar PDF enviado de "
    let mensaje2 = "Eliminar PDF recibido de "
    let mensajeAsImCoti2 = "Asociar PDF recibido de "
    let mensaje3 = "COTIZACION APROBADA"
    let mensaje4 = "COTIZACION RECHAZADA"  
    let mensaje5 = "MODIFICAR DATOS" 
    let mensaje6 = "Grabar"  
    let imgIcon1 = "images/archivo_32.png"
    let mensaje7 = "REVERSAR " 
    if(idListaP.numCoti){
      // mensaje1 += idListaP.numCoti
      // mensajeAsImCoti += idListaP.numCoti
      mensaje2 += idListaP.numCoti
      mensaje7 += idListaP.numCoti
      mensajeAsImCoti2 += idListaP.numCoti
    }else{
      // mensaje1 += "(Seleccionar...)"
      // mensajeAsImCoti += "(Seleccionar...)"
      mensaje2 += "(Seleccionar...)"
      mensajeAsImCoti2 += "(Seleccionar...)"
    }


  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Cotizaciones enviadas" btnNuevo={"NO"} styles={this.props.styles}/>

        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.props.handleElimAsDocCoti(ev, idListaP, 'E')
              :permiteBtn2?
                (ev)=>this.props.handleElimAsDocCoti(ev, idListaP, 'R')
                // :permiteBtn3?
                // (ev)=>this.handleReversar(ev, idListaP)
                :()=>{}                
            :()=>{}}
          > 
            <div className="ui six column stackable grid">
              {/* <div className="column" style={{width: '23%', paddingTop: '0em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    
                  </label>
                }
              </div> */}
              {/* <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    {mensajeAsImCoti}
                  </label>
                }
              </div> */}
              {idListaP.numCoti && !idListaP.archivoRecibido &&
                <div className="column" style={{width: '18%', paddingTop: '0em'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      {mensajeAsImCoti2}
                    </label>
                  
                </div>
              }
            </div>
            <div className="ui five column stackable grid">
              {/* <div className="column" style={{width: '23%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaEmp styles={this.props.styles} list={list2}
                    handleChange={this.handleChange} />
                </Form.Field>
              </div> */}
              {/* <div className="column" style={{width: '20%', paddingLeft: '1.2em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <Form.Field>
                    <input id="img" name="img" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocCoti(ev, idListaP, 'E')}></input>
                  </Form.Field>
                } 
              </div> */}
              {idListaP.numCoti && !idListaP.archivoRecibido &&
                <div className="column" style={{width: '18%', paddingLeft: '1.2em'}}>
                
                    <Form.Field>
                      <input id="img2" name="img2" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocCoti(ev, idListaP, 'R')}></input>
                    </Form.Field>
                </div>
              }
              {idListaP.numCoti && idListaP.archivoRecibido &&
                <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                  <EstaSeguro mensaje2={mensaje2} 
                  // imgIcon1={imgIcon1} 
                    open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                </div>
              }    
              <div className="column" style={{width: '6%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Form.Field>
                    <label style={this.props.styles.label}>Valor total OC cliente:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '11%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Form.Field>
                    <Form.Input type='number' step="0.1" autoComplete="off" name="totalOC" id="totalOC" value={argsDocum.totalOC?argsDocum.totalOC:0} onChange={(ev)=>this.handleChangeTotal(ev)} placeholder='Total OC'/>
                  </Form.Field>                
                }
              </div>   
              <div className="column" style={{width: '6%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Form.Field>
                    <label style={this.props.styles.label}># OC cliente:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '9%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Form.Field>
                    <Form.Input autoComplete="off" name="ordenCompraCliente" id="ordenCompraCliente" value={argsDocum.ordenCompraCliente?argsDocum.ordenCompraCliente:''} onChange={(ev)=>this.handleChangeTotal(ev)} placeholder='OC del cliente' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'ordenCompraCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>                
                }
              </div> 
              <div className="column" style={{width: '6%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha OC cliente:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '12%', paddingTop: '0.3em'}}>
                {idListaP.numCoti &&
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="fechaOrdenCliente" id="fechaOrdenCliente" value={idListaP.fechaOrdenCliente?idListaP.fechaOrdenCliente:argsDocum.fechaOrdenCliente?argsDocum.fechaOrdenCliente:this.props.fechaHoy} onChange={this.handleChangeTotal}/>
                  </Form.Field>
                }
              </div>
              <div className="column" style={{width: '9%', paddingTop: '0.3em'}}>
                {idListaP.numCoti && 
                  <Button id="total" name="total" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleTotal(idListaP, argsDocum.totalOC, argsDocum.ordenCompraCliente, argsDocum.fechaOrdenCliente)} fluid>
                    {mensaje6}
                  </Button>                  
                }
              </div>    
              {idListaP.numCoti &&
                <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    {/* <EstaSeg7Btn mensaje7={mensaje7} imgIcon7={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "3")}/> */}
                  <Button id="reversar" name="reversar" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleReversar(idListaP)} fluid>
                    {mensaje7}
                  </Button>                  
                </div>
              }   
              {/* </div> */}
            </div>
            <div style={{height: '16em', overflow: 'auto'}}>a
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cod. cotización</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Empresa</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Responsable</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', pddingBottom: '0.4em', width: '6%'}}>Tipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor sin IVA</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor con IVA</th>    
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Total OC cliente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>No. OC cliente</th>    
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha OC cliente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Contacto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha envío cotización</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Validez de la oferta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Archivo enviado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Archivo recibido</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
            <div className="ui two column stackable grid">
              <div className="column" style={{width: '50%', paddingTop: '1.9em'}}>
                {idListaP.numCoti && 
                  <Button id="aprob" name="aprob" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleRtaCoti(idListaP, 'Aceptada', list4)} fluid>
                    {mensaje3}
                  </Button>
                }
              </div>
              <div className="column" style={{width: '50%', paddingTop: '1.9em'}}>
                {idListaP.numCoti && 
                  <Button id="rechaz" name="rechaz" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleRtaCoti(idListaP, 'Rechazada', list4)} fluid>
                    {mensaje4}
                  </Button>                  
                }
              </div>
            </div>
            <div style={{height: '16em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '27%'}}>Producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Precio actual</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Valor unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>% Descuento</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>% Incremento</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Total producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>% Impto</th>
                  </tr>
                </thead>
                <Lista listI={list4} handleClickidListaI={this.handleClickidListaI} idListaI={idListaI}/>
              </table>
              <p></p>
            </div>
            <div className="ui five column stackable grid">
              <div className="column" style={{width: '10%', paddingTop: '2.2em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <label style={this.props.styles.label}>Cantidad de {idListaI.descrProducto}:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <Form.Input type='number' step="0.1" min="0.1" autoComplete="off" name="cantidadAprob" id="cantidadAprob" value={argsDocumI.cantidadAprob} onChange={(ev)=>this.handleChangeI(ev, idListaP.numCoti, idListaI.descrProducto)} placeholder='cantidad'/>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '2.2em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <label style={this.props.styles.label}>% de DCto de {idListaI.descrProducto}:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <Form.Input type='number' step="0.1" min="0" autoComplete="off" name="porcDcto" id="porcDcto" value={argsDocumI.porcDcto} onChange={(ev)=>this.handleChangeI(ev, idListaP.numCoti, idListaI.descrProducto)} placeholder='% Dcto'/>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '2.2em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <label style={this.props.styles.label}>% de incremento de {idListaI.descrProducto}:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <Form.Input type='number' step="0.1" min="0" autoComplete="off" name="porcIncremento" id="porcIncremento" value={argsDocumI.porcIncremento} onChange={(ev)=>this.handleChangeI(ev, idListaP.numCoti, idListaI.descrProducto)} placeholder='% Incremento'/>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '30%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Button id="canti" name="canti" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCantidad(idListaP, idListaI, argsDocumI.cantidadAprob, argsDocumI.porcDcto, argsDocumI.porcIncremento)} fluid>
                    {mensaje5}
                  </Button>                  
                }
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
  )
  }
};

export default compose( 
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesAsoc1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Enviada'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesAsoc',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Enviada'}},
    {"$unwind": "$itemsCoti"},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
    monedaCoti: 1, imptoCoti: 1, fechaOrdenCliente: 1,
    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
    archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, ordenCompraCliente: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
    porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},
  {$match: {cantidadAprob: {$gt: 0}}},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
    monedaCoti: 1, imptoCoti: 1, fechaOrdenCliente: 1,
    ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
    validezOferta: 1, observacionesAut: 1, usuarioAut: 1, archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, ordenCompraCliente: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, 
    valorItemAsoc: {
      $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
      }
    },
    valorItemAsocIVA: {
      $let: {
        vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
        in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
      }
    }
  }},
{$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
  fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti', fechaOrdenCliente: '$fechaOrdenCliente',
descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
  cargoContacto: '$cargoContacto', archivoEnviado: '$archivoEnviado', archivoRecibido: '$archivoRecibido', 
ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
  referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
  formaPago: '$formaPago', totalOC: '$totalOC', ordenCompraCliente: '$ordenCompraCliente',
validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
  estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3'},
valorTotalAsoc: {$sum: {$toDouble: '$valorItemAsoc'}}, valorTotalAsocIVA: {$sum: {$toDouble: '$valorItemAsocIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
    numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
    fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
    monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti', fechaOrdenCliente: '$_id.fechaOrdenCliente',
    fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
      ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
      nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
      referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
      formaPago: '$_id.formaPago', archivoEnviado: '$_id.archivoEnviado', totalOC: '$_id.totalOC', 
      ordenCompraCliente: '$_id.ordenCompraCliente', archivoRecibido: '$_id.archivoRecibido', 
      validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
      estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', 
      valorUniAprob: {$toDouble: '$valorTotalAsoc'}, cantidadAprob: {$toDouble: '$valorTotalAsocIVA'},
      numOrdenCompra: {
        $let: {
          vars: {fechaEnvioDif: "$_id.fechaEnvio"},
         in: {$cond: [
           {
             "$or":[
              { "$eq": [ "$$fechaEnvioDif", null ] },
              { "$eq": [ "$$fechaEnvioDif", '' ]},
             ]
           }, 
           1,
           { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaEnvioDif'} ]}, 86400000 ]}}
          ]
        }}
      }
  }}, {$sort: {fechaEnvio: -1}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  
  graphql(queries.query.allEncuesta, {name:'allEncuesta'}), 

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(AsocDocCoti2)
